<template lang="pug">
  div(class="py-ds-sm px-ds-md xl:w-full text-red-primary flex bg-gray-110 border border-solid border-red-primary rounded-md")
    Icon.flex-none(
      :size="16"
      name="i:triangle-exclamation-solid")
    div(class="relative inline-block font-bold text-sm top[-1px] ml-ds-sm leading-normal")
      slot
</template>

<script lang="ts">
export default {
  name: "TextInputError"
}
</script>
